import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: 'Respiratory Rate Chart',
  },
  timeWindow: 7 * 4,
  childProps: {
    type: 'respiratory_rate',
    yAxisLabel: 'Respiratory Rate (breaths per minute)',
    title: chartTitles.respiratory_rate,
  },
})
